import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { COLORS, FONT_FAMILY } from "../../constants/color";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const ConfirmDialog = ({
  open,
  title,
  message,
  onConfirm,
  onCancel,
  confirmText = "Delete",
  cancelText = "Cancel",
  isDanger = true,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      PaperProps={{
        sx: {
          borderRadius: "12px",
          padding: 1,
          minWidth: "400px",
        },
      }}
    >
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        {isDanger && (
          <WarningAmberIcon sx={{ color: "error.main", fontSize: 28 }} />
        )}
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: "20px",
            fontFamily: FONT_FAMILY,
            color: COLORS.PRIMARY,
          }}
        >
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ pb: 1 }}>
        <DialogContentText
          sx={{
            fontFamily: FONT_FAMILY,
            color: COLORS.MUTED_TEXT,
            fontSize: "15.5px",
            lineHeight: 1.6,
          }}
        >
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 3, pt: 1, gap: 2 }}>
        <Button
          onClick={onCancel}
          sx={{
            textTransform: "none",
            fontWeight: 600,
            fontFamily: FONT_FAMILY,
            color: COLORS.SECONDARY,
            fontSize: "15px",
            px: 2,
            "&:hover": {
              backgroundColor: "rgba(101, 45, 144, 0.04)",
            },
          }}
        >
          {cancelText}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color={isDanger ? "error" : "primary"}
          sx={{
            textTransform: "none",
            fontWeight: 700,
            fontFamily: FONT_FAMILY,
            borderRadius: "10px",
            px: 4,
            py: 1,
            fontSize: "15px",
            boxShadow: "0px 4px 12px rgba(239, 68, 68, 0.25)",
            "&:hover": {
              boxShadow: "0px 6px 16px rgba(239, 68, 68, 0.35)",
              backgroundColor: isDanger ? "#d32f2f" : undefined,
            },
          }}
        >
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
